import React from 'react'
import { Flow, FlowName, FlowScreenElement } from '../../../../../@types/flow-types'
import { FeatureSwitch } from '../../../../../utils/features/featureSwitches'
import { MultimediaUploaderType } from '../../../../../@types/multimedia-types'
import { RealEstateCategory, SegmentationType, TransactionType } from '../../../../../@types/types'
import Address from '../../../../../components/pages/insertionPage/screens/address/Address'
import Connections from '../../../../../components/pages/insertionPage/screens/connections/Connections'
import ContactInfo from '../../../../../components/pages/insertionPage/screens/contactInfo/ContactInfo'
import CommercialCostsRent from '../../../../../components/pages/insertionPage/screens/costs/wrappers/commercial/CommercialCostsRent'
import Description from '../../../../../components/pages/insertionPage/screens/description/Description'
import Multimedia from '../../../../../components/pages/insertionPage/screens/multimediaNew/Multimedia'

import {
  SCREEN_ADDRESS,
  SCREEN_CONNECTIONS,
  SCREEN_CONTACT_INFO,
  SCREEN_COSTS,
  SCREEN_DESCRIPTION,
  SCREEN_MULTIMEDIA,
  SCREENS,
} from '../../../../../services/domain/wizardScreens'
import { TENANT_OFFICE_RENT_FLOW_PATH } from '../../../../../services/routes/routes'
import {
  officeRentBasicInfoScreen,
  officeRentOtherFacilities,
} from '../../propertyOwner/office/propertyOwnerOfficeRentFlow'
import { tenantOfficeRentSchema } from './tenantOfficeRentSchema'

const tenantOfficeRentFlowScreens: FlowScreenElement[] = [
  {
    screen: SCREENS[SCREEN_ADDRESS],
    element: (props) => <Address {...props} />,
  },
  officeRentBasicInfoScreen,
  {
    screen: SCREENS[SCREEN_COSTS],
    element: (props) => (
      <CommercialCostsRent
        {...props}
        hasRentDuration={true}
        hasMoveInDate={true}
        screenTooltipKey='tooltip.screens.costs.allRent'
      />
    ),
  },
  {
    screen: SCREENS[SCREEN_DESCRIPTION],
    element: (props) => <Description {...props} hasLocationNote={true} />,
  },
  {
    screen: SCREENS[SCREEN_MULTIMEDIA],
    element: (props) => (
      <Multimedia
        {...props}
        doCloseMultimediaStatusMessage={props.doCloseMultimediaStatusMessage!}
        allowedTypesToDisplay={[MultimediaUploaderType.PICTURE, MultimediaUploaderType.VIDEO]}
      />
    ),
  },
  officeRentOtherFacilities,
  {
    screen: SCREENS[SCREEN_CONNECTIONS],
    element: (props) => <Connections {...props} />,
  },
  {
    screen: SCREENS[SCREEN_CONTACT_INFO],
    element: (props) => <ContactInfo {...props} />,
  },
]

export const tenantOfficeRentFlow: Flow = {
  flowInformation: {
    owner: 'wizard.navigation.header.tenant',
    estateType: 'wizard.navigation.header.office',
    path: TENANT_OFFICE_RENT_FLOW_PATH,
    name: FlowName.TENANT_OFFICE_RENT,
    validationSchema: tenantOfficeRentSchema,
    options: {
      hasTextSuggestions: true,
      textSuggestionsFeature: FeatureSwitch.PPA_12428_AI_TEXT_GENERATION_DEVCOM_RENT,
    },
    metaData: {
      category: RealEstateCategory.OFFICE,
      segmentation: SegmentationType.TENANT,
      transaction: TransactionType.RENT,
    },
  },
  defaultStateValues: {
    hideStreetAndStreetNumber: false,
  },
  flowScreens: tenantOfficeRentFlowScreens,
}
